  import "./globals";
import React from "react";
import ReactDOM from "react-dom";
 import "./index.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
// import { createStore } from "redux";
import { Provider } from "react-redux";
// import reducer from "./Redux/reducer";
// import IndexReducer from "./Redux/Reducers/IndexReducer";
import ReduxStore from "./Redux/Store/IndexStore";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Common/Assets/Styles/theme.scss";
import "./Common/Assets/Styles/main.scss";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
// const store = createStore(reducer);
// const store = createStore(IndexReducer);

ReactDOM.render(
  // <Provider store={store}>
  <Provider store={ReduxStore}>
    <App />
  </Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();
